import React, { useState } from 'react';
import Styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isMobile, isTablet, crossSiteCheckUrl } from './Helpers';
import { getPlansData } from '../../utils/plansReference';
import Button from './Button';
import CommonModal from './Modal';
import { eventDispatcher } from './Tagging';

const SignInDiv = Styled.div`
text-align: right;
  float: right;
  width: ${isMobile() ? '309px' : isTablet() ? '700px' : '1200px'};
  @media all and (device-width: 320px) {
      width: 267px;
    }
  @media (device-width: 1024px) {
    width: 900px;
  }
    height: 40px;
    color: white;
    font-weight: bold;
    font-size: 16px !important;
    cursor: pointer;
    `;

const SignInLink = (props) => {
  const [signInModal, setsignInModal] = useState(false);
  const [showSignIn, setShowSignIn] = useState(true);
  const getAMURL = () => {
    const hostName = window.location.hostname;
    let APIContext = '';
    if (hostName.indexOf('.verizonwireless.com') > -1) {
      const qaEnv = window.location.host.split('.');
      const lowerEnv = qaEnv && qaEnv[0].substr(qaEnv[0].length - 3);
      const number = lowerEnv?.match(/(\d+)/);
      if (number?.[0] > 9) {
        APIContext = `https://accessmgrqa${number[0]}.verizonwireless.com/vzauth/UI/Login?realm=vzw&goto=https://vzwqa${
          number[0]
        }.verizonwireless.com/sales/home/expresscart.html?expresscart=true%26signinfromplans%3dtrue&userNameOnly=false&rememberUserNameCheckBoxExists=Y&offerShortLivedPassword=Y&mode=o`;
      } else {
        // APIContext = `https://accessmgr${lowerEnv}.verizonwireless.com/vzauth/UI/Login?realm=vzw&goto=https://vzw${lowerEnv}.verizonwireless.com/sales/home/expresscart.html?expresscart=true%26signinfromplans%3dtrue&userNameOnly=false&rememberUserNameCheckBoxExists=Y&offerShortLivedPassword=Y&mode=o`;
        APIContext = `https://securesit${number?.[0]}.verizon.com/signin?mode=i&userNameOnly=true&clientId=VZCOMBQ&goto=https%3A%2F%2Fvzwqa${
          number?.[0]
        }.verizonwireless.com%2Fsales%2Fhome%2Fexpresscart.html%3Fexpresscart%3Dtrue%26signinfromplans%3dtrue`;
      }
    } else {
      APIContext =
        props.plansReferenceData?.signInProdNSAUrl ||
        'https://secure.verizon.com/signin?mode=i&userNameOnly=true&clientId=VZCOMBQ&goto=https://www.verizon.com/sales/home/expresscart.html?expresscart=true%26signinfromplans%3dtrue';
    }
    return `${APIContext}`;
  };
  const redirectUrl = crossSiteCheckUrl(getAMURL());
  const getSignInUrl = () => {
    setsignInModal(true);
    const obj = { name: 'sign in modal opened', selector: '#signinOverlay', data: { page: { throttle: 'nsa version|vhi|sign in' } } };
    eventDispatcher('openView', obj);
  };
  const toggleShowModal = (value) => {
    setsignInModal(value);
    setShowSignIn(!value);
  };

  return (
    <React.Fragment>
      <SignInDiv>
        {showSignIn && (
          <Button
            onClick={() => getSignInUrl()}
            onKeyPress={() => getSignInUrl()}
            type="button"
            id="signinbtn"
            aria-label="sign in"
            data-track='{"type": "link", "name": "sign in", "data":{"page":{"throttle":"nsa version|vhi|sign in" }}}'
            primary
          >
            Sign in
          </Button>
        )}
      </SignInDiv>
      {signInModal && (
        <CommonModal
          id="signinOverlay"
          opened={signInModal}
          ariaLabel="sign in modal opened"
          analyticstrack="sign in modal opened"
          onOpenedChange={toggleShowModal}
          className="impTopPad6 modalStyle"
          disableOutsideClick
          modalBody=<iframe id="signinframe" height="600px" width="400px" title={redirectUrl} src={redirectUrl} />
        />
      )}
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  const plansReferenceData = getPlansData(state.plansReferenceData);
  return {
    plansReferenceData,
  };
};
SignInLink.propTypes = {
  plansReferenceData: PropTypes.object,
};
export default connect(mapStateToProps)(SignInLink);
